const BRAND_COLOR = '#66A573'
const BRAND_COLOR_DARK = '#4d8a5a'
const APP_NAME = 'Ask QUIEN'
const APP_NAME_HTML = `<span style="font-family:'SFMono-Regular',Consolas,'Liberation Mono',monospace;font-weight:700;color:${BRAND_COLOR};">Ask QUIEN</span>`
const LOGO_URL = 'https://quality-intelligence.co/brand/qi-mark.png'

export function buildMagicLinkEmail(url: string, host: string): { subject: string; html: string; text: string } {
  const subject = `Your sign-in link for ${APP_NAME}`

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${subject}</title>
</head>
<body style="margin:0;padding:0;background-color:#f4f4f5;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f5;padding:40px 16px;">
    <tr>
      <td align="center">
        <table width="100%" cellpadding="0" cellspacing="0" style="max-width:480px;">

          <!-- Logo / brand header -->
          <tr>
            <td align="center" style="padding-bottom:24px;">
              <img src="${LOGO_URL}" width="64" height="64" alt="${APP_NAME}" style="display:block;border-radius:12px;" />
              <p style="margin:12px 0 0;font-size:18px;">${APP_NAME_HTML}</p>
            </td>
          </tr>

          <!-- Card -->
          <tr>
            <td style="background-color:#ffffff;border-radius:12px;border:1px solid #e4e4e7;padding:40px 40px 32px;">
              <table width="100%" cellpadding="0" cellspacing="0">

                <tr>
                  <td style="padding-bottom:8px;">
                    <p style="margin:0;font-size:22px;font-weight:700;color:#18181b;letter-spacing:-0.4px;">Sign in to ${APP_NAME_HTML}</p>
                  </td>
                </tr>

                <tr>
                  <td style="padding-bottom:28px;">
                    <p style="margin:0;font-size:15px;line-height:1.6;color:#52525b;">
                      Click the button below to sign in. This link is valid for <strong>10 minutes</strong> and can only be used once.
                    </p>
                  </td>
                </tr>

                <!-- CTA button -->
                <tr>
                  <td align="center" style="padding-bottom:28px;">
                    <a href="${url}"
                       style="display:inline-block;background-color:${BRAND_COLOR};color:#ffffff;text-decoration:none;font-size:15px;font-weight:600;padding:14px 32px;border-radius:8px;letter-spacing:0.1px;"
                       onmouseover="this.style.backgroundColor='${BRAND_COLOR_DARK}'"
                       onmouseout="this.style.backgroundColor='${BRAND_COLOR}'">
                      Sign in to ${APP_NAME}
                    </a>
                  </td>
                </tr>

                <!-- Fallback link -->
                <tr>
                  <td style="padding-bottom:24px;border-top:1px solid #f4f4f5;padding-top:20px;">
                    <p style="margin:0 0 6px;font-size:12px;color:#71717a;font-weight:500;text-transform:uppercase;letter-spacing:0.5px;">Button not working?</p>
                    <p style="margin:0;font-size:12px;color:#71717a;">Paste this link into your browser:</p>
                    <p style="margin:6px 0 0;font-size:11px;word-break:break-all;">
                      <a href="${url}" style="color:${BRAND_COLOR};text-decoration:none;">${url}</a>
                    </p>
                  </td>
                </tr>

                <!-- Security note -->
                <tr>
                  <td>
                    <p style="margin:0;font-size:12px;color:#a1a1aa;line-height:1.5;">
                      If you didn&rsquo;t request this email, you can safely ignore it. Someone may have entered your email address by mistake.
                    </p>
                  </td>
                </tr>

              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td align="center" style="padding-top:24px;">
              <p style="margin:0;font-size:12px;color:#a1a1aa;">&copy; ${new Date().getFullYear()} Quality Intelligence &middot; <a href="https://${host}" style="color:#a1a1aa;text-decoration:none;">${host}</a></p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`

  const text = `Sign in to ${APP_NAME}\n\nClick the link below to sign in. This link is valid for 10 minutes.\n\n${url}\n\nIf you didn't request this, you can safely ignore this email.\n\n— ${APP_NAME} / ${host}`

  return { subject, html, text }
}
